import { render, staticRenderFns } from "./GroupInviteRembers.vue?vue&type=template&id=68c1f9a2&scoped=true"
import script from "./GroupInviteRembers.vue?vue&type=script&lang=js"
export * from "./GroupInviteRembers.vue?vue&type=script&lang=js"
import style0 from "./GroupInviteRembers.vue?vue&type=style&index=0&id=68c1f9a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c1f9a2",
  null
  
)

export default component.exports